import React from 'react';
import T from 'components/T';

type Props = {
  actions: {
    confirmAccuracy: () => void;
    switchToDisputeModal: () => void;
  };
  companyName: string;
};

const ConfirmForm = ({ actions, companyName }: Props) => (
  <div data-testid='confirm-form'>
    <div className='form-group'>
      <p>
        <T
          value='components.Report.CandidateStories.Modal.Confirm.beforeYouProvide'
          company={companyName}
        />
      </p>
      <span className='form-question'>
        <T value='components.Report.CandidateStories.Modal.Confirm.isEverythingAccurate' />
      </span>
      <hr />
    </div>
    <div className='form-group'>
      <div
        className='d-flex justify-content-between tile-option-select p-4 mb-2 rounded'
        onClick={actions.confirmAccuracy}
        role='button'
        tabIndex={0}
        data-testid='candidate-stories-confirm-btn'
      >
        <div>
          <T
            value='components.Report.CandidateStories.Modal.Confirm.yesAccurate'
            company={companyName}
            dangerousHTML
          />
        </div>
      </div>
      <div
        className='d-flex justify-content-between tile-option-select p-4 mb-2 rounded'
        onClick={actions.switchToDisputeModal}
        role='button'
        tabIndex={0}
      >
        <div data-testid='candidate-stories-no-wrong-button'>
          <T
            value='components.Report.CandidateStories.Modal.Confirm.noWrong'
            dangerousHTML
          />
        </div>
      </div>
    </div>
  </div>
);

export default ConfirmForm;
